import React, {useState, useEffect} from "react";
import {ReactComponent as PhoneBackIcon} from "../../images/other/icons/phoneBack.svg";
import {ReactComponent as PhoneCallIcon} from "../../images/other/icons/phoneCall.svg";
import people, {currentPlayer} from "../people/people";
import variables from "../variables";
import {notify} from "./functions";
import Name from "../../features/Name";
import i18next from "i18next";

const Contacts = () => {
    const [who, setWho] = useState('contacts');

    useEffect(() => {
        const ps = document.getElementsByTagName("p");
        const lastP = ps[ps.length - 1];
        if (lastP) lastP.scrollIntoView();
    }, [who])

    const getMessagesAsList = () => {
        const messages = [];
        variables.wife.messages[who].forEach( item => {
            people[who].messages[item].forEach(mes => {
                const who_ = Object.keys(mes)[0];
                const what = Object.keys(mes[who_])[0];
                const emoji = what === "emoji" ? " no-tail emoji" : "";
                const content = what !== "image" ? i18next.t(mes[who_][what]) : <img src={mes[who_][what][0][mes[who_][what][1]]} alt=""/>
                messages.push({ className: `from-${who_}${emoji}`, content })
            });
        });
        return messages;
    };

    const getIMessage = () => (
            <div className="imessage">
                {getMessagesAsList().map((item, key)=> (
                    <p className={item.className} key={key}>{item.content}</p>
                ))}
            </div>
        );

    const onListItemClick = e => {
        const contact = e.target.dataset.who;
        setWho(contact);
        if (variables.wife.newMessage === people[contact].id)
            variables.wife.newMessage = "";
    };

    const onBackButtonClick = () => setWho("contacts");

    const onPhoneIconClick = () => {
        if (currentPlayer.isPlayer()) notify(<span>To call someone you need to play as <Name who={people.wife} noStyle/></span>)
        else notify(<span><Name who={people.wife}/> doesn't want to call anyone...</span>);
    };

    const getContactsList = () => {
        return (
            <div>
                <div className="content">
                    <ul className="contacts-list">
                        {Object.keys(variables.wife.messages).map((contact, key) => {
                            console.log(contact);
                            if (!["update", "oldJSON", "initJSON"].includes(contact))
                                return (
                                    <li
                                        key={key}
                                        data-who={contact}
                                        onClick={onListItemClick}
                                        style={variables.wife.newMessage === people[contact].id ? {border: "solid red"} : {}}
                                    >
                                        {people[contact].name} ({people[contact].who})
                                    </li>
                                );
                        })}
                    </ul>
                </div>
            </div>
        )
    };

    return (
        <div className="contacts">
            <h2 className="header">Contacts</h2>
            {
                who !== "contacts" && <div className="imessage-header">
                    <span className="back-icon" onClick={onBackButtonClick}>
                        <PhoneBackIcon style={{width: "15px", height: "15px", marginTop: "5px"}}/>
                    </span>
                    <span className="contact-name">{people[who].name}</span>
                    <span className="phone-icon" onClick={onPhoneIconClick}><PhoneCallIcon style={{width: "25px", height: "25px"}}/></span>
                </div>
            }
            <div className="content" style={who === "contacts" ? {height: "400px"} : {height: "355px"}}>
                <div className="content-type">
                    {who === "contacts" ? getContactsList() : getIMessage()}
                </div>
            </div>
        </div>
    )
};

export default Contacts;